// extracted by mini-css-extract-plugin
export default {"content_header":"ContentHeader_content_header__pMc6d","title_container":"ContentHeader_title_container__r9itS","description":"ContentHeader_description__sis6-"};